// extracted by mini-css-extract-plugin
export var footer = "_np-5";
export var fulfillmentInput = "_np-0";
export var shipDateInput = "_np-1";
export var shipmentModal = "_np-2";
export var shipmentModalContent = "_np-3";
export var tableContainer = "_np-4";